export default {
    liveChart: {
        datasetLabel: '{product} profil',
        binLabel: 'Interval {index}',
        ariaLabel: 'Grafikon profila za {date}, {product}, {count} intervalov',
    },
}
